import React, { ReactElement } from 'react';
import { QHeading, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { ReassignEventTemplatesMap } from '../../types';
import { filterUniqueOwners } from '../../utils';

type PropsType = {
  defaultAssigneeItems: ReassignEventTemplatesMap;
  ownerItems: ReassignEventTemplatesMap;
};

/**
 * This exists because the Event Template reassign summary is slightly different then the rest in how
 * it displays the reassign string
 */
const ReassignEventTemplateSummaryItem = ({ defaultAssigneeItems, ownerItems }: PropsType): ReactElement => {
  const { t } = useTranslation();
  const uniqueDefaultAssignees = filterUniqueOwners(defaultAssigneeItems);
  const uniqueOwners = filterUniqueOwners(ownerItems);
  return (
    <QHeading size="sm" fontSize="md" fontWeight="bold">
      {t('reassignEntities.summary.eventTemplates')}
      {uniqueDefaultAssignees.map(([owner, count]) => {
        const translationKey =
          count === 1
            ? 'reassignEntities.summary.eventTemplateTransfer'
            : 'reassignEntities.summary.eventTemplateTransferPlural';
        const translatedText = t(translationKey, { ownershipType: 'Default ownership', count, name: owner });

        return (
          <QText key={owner} fontSize="xs" fontWeight="light">
            {translatedText}
          </QText>
        );
      })}
      {uniqueOwners.map(([owner, count]) => {
        const translationKey =
          count === 1
            ? 'reassignEntities.summary.eventTemplateTransfer'
            : 'reassignEntities.summary.eventTemplateTransferPlural';
        const translatedText = t(translationKey, { ownershipType: 'Ownership', count, name: owner });

        return (
          <QText key={owner} fontSize="xs" fontWeight="light">
            {translatedText}
          </QText>
        );
      })}
    </QHeading>
  );
};

export default ReassignEventTemplateSummaryItem;
